/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: blacklistActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Incoming Call Tools module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteBlacklistEntry } from './api';

/**
 * Shared helpers for Blacklist module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a Blacklist entry in the form.
 * Pattern: /pbx/incoming-tools/blacklist/new?duplicate={id}
 */
export const getBlacklistDuplicateUrl = (id: string | number): string =>
  `/pbx/incoming-tools/blacklist/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Blacklist entry id.
 */
export const navigateToBlacklistDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getBlacklistDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a Blacklist entry by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 * @deprecated Use deleteBlacklistEntry from './api' instead
 */
export const deleteBlacklistById = async (id: string | number): Promise<void> => {
  await deleteBlacklistEntry(id);
};

